import { render, staticRenderFns } from "./EditContractType.vue?vue&type=template&id=481f4632&"
import script from "./EditContractType.vue?vue&type=script&lang=js&"
export * from "./EditContractType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports